
import { commonUrl, deleteRequest,  getRequest,  ResponseDI } from "../../../base/services/urlService"
import {  Id } from "../types"

interface DeleteLessonResponseResultDI {
    
}



export const deleteLesson2 = async (id:Id) => {
    
    const response = await  deleteRequest<ResponseDI<DeleteLessonResponseResultDI>>(`${commonUrl}/api/lesson/deleteLesson?id=${id}`)
    return response.result
}


export const deleteLesson = async (id: Id) => {
  const url = `${commonUrl}/api/lesson/deleteLesson?id=${id}`;
  const { result } = await getRequest<ResponseDI<DeleteLessonResponseResultDI>>(url);
  return result;
};
